import { QueryClientProvider } from "@tanstack/react-query"
import { LucideProvider } from "lucide-react"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import CacheProvider from "react-inlinesvg/provider"

import { ThemeProvider, Toaster, TooltipProvider } from "@atlant/ui"

import { queryClient } from "#/providers/query-client.ts"
import { Loader } from "#components/loader.tsx"

import "./index.css"

import { createRouter, RouterProvider } from "@tanstack/react-router"

import { AuthProvider, useAuth } from "#lib/auth.tsx"

import { routeTree } from "./routeTree.gen"

const router = createRouter({
  routeTree,
  context: { auth: undefined! },
  defaultPreload: "intent",
})

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}

function InnerApp() {
  const auth = useAuth()

  if (auth.isPending) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader className="text-primary size-12 animate-[spin_1.2s_linear_infinite]" />
      </div>
    )
  }

  return <RouterProvider router={router} context={{ auth }} />
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <CacheProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <TooltipProvider>
            <ThemeProvider
              attribute="class"
              defaultTheme="light"
              disableTransitionOnChange
            >
              <LucideProvider>
                <Toaster richColors expand visibleToasts={5} gap={10} />
                <InnerApp />
              </LucideProvider>
            </ThemeProvider>
          </TooltipProvider>
        </AuthProvider>
      </QueryClientProvider>
    </CacheProvider>
  </StrictMode>,
)
